(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-test-product]').forEach((root) => {
      if (root.dataset.initialised) return;
      const dataElement = root.querySelector('[data-test-config]');
      const form = root.querySelector('.bb-product-form');
      if (!dataElement || !form) return;
      let config;
      try { config = JSON.parse(dataElement.textContent); } catch { return; }
      root.dataset.initialised = 'true';
      const variantInput = root.querySelector('[data-variant-select]');
      const error = root.querySelector('[data-cart-error]');
      const mainButton = root.querySelector('[data-main-submit]');
      const stickyButton = root.querySelector('[data-sticky-submit]');
      const sticky = root.querySelector('[data-sticky-purchase]');
      const upsell = root.querySelector('[data-upsell-id]');
      const launchReady = root.dataset.launchReady === 'true';
      const buttons = [mainButton, stickyButton].filter(Boolean);
      let pending = false;
      const currentVariant = () => config.variants.find((variant) => String(variant.id) === variantInput.value);
      const currentQuantity = () => Number(form.querySelector('[name="quantity"]:checked')?.value || 1);
      const replaceText = (selector, value) => root.querySelectorAll(selector).forEach((element) => { element.textContent = value; });
      const formatMoney = (cents) => {
        try {
          return new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: config.currency, currencyDisplay: 'code' }).format(cents / 100);
        } catch {
          return `${(cents / 100).toFixed(2)} ${config.currency}`;
        }
      };
      const chooseImage = (button) => {
        const mainImage = root.querySelector('[data-main-image]');
        if (!mainImage || !button) return;
        mainImage.srcset = button.dataset.imageSrcset;
        mainImage.src = button.dataset.imageSrc;
        mainImage.alt = button.dataset.imageAlt;
        root.querySelectorAll('[data-gallery-image]').forEach((thumbnail) => thumbnail.setAttribute('aria-pressed', String(thumbnail === button)));
      };
      const update = () => {
        const variant = currentVariant();
        const available = launchReady && Boolean(variant?.available);
        const label = pending ? config.labels.loading : !launchReady ? config.labels.soon : available ? config.labels.add : config.labels.soldOut;
        replaceText('[data-submit-label]', label);
        buttons.forEach((button) => {
          button.disabled = !available || pending;
          button.setAttribute('aria-busy', String(pending));
        });
        if (!variant) return;
        const hasPrice = variant.price > 0;
        replaceText('[data-single-price]', hasPrice ? variant.formatted : config.labels.priceSoon);
        replaceText('[data-pair-price]', hasPrice ? variant.pairFormatted : config.labels.priceSoon);
        replaceText('[data-pair-original]', variant.pairOriginal);
        replaceText('[data-pair-saving-label]', variant.pairSavingLabel);
        const quantity = currentQuantity();
        const total = quantity === 2 ? variant.pairPrice : variant.price;
        const extra = upsell?.checked ? Number(upsell.dataset.upsellPrice) : 0;
        const formatted = extra ? formatMoney(total + extra) : quantity === 2 ? variant.pairFormatted : variant.formatted;
        replaceText('[data-selection-total]', hasPrice ? formatted : config.labels.priceSoon);
        replaceText('[data-sticky-price]', hasPrice ? formatted : config.labels.priceSoon);
      };
      root.querySelectorAll('[data-gallery-image]').forEach((button) => button.addEventListener('click', () => chooseImage(button)));
      form.addEventListener('change', (event) => {
        if (event.target === variantInput) {
          const variant = currentVariant();
          if (variant?.imageId) chooseImage(root.querySelector(`[data-image-id="${variant.imageId}"]`));
          if (variant?.id) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
          }
        }
        if (error) error.hidden = true;
        update();
      });
      root.querySelector('[data-upsell-wrapper]')?.removeAttribute('hidden');
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const variant = currentVariant();
        if (pending || !launchReady || !variant?.available) return;
        pending = true;
        error.hidden = true;
        update();
        const items = [{ id: variant.id, quantity: currentQuantity() }];
        if (upsell?.checked) items.push({ id: Number(upsell.dataset.upsellId), quantity: 1 });
        try {
          const response = await fetch(root.dataset.addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json().catch(() => ({}));
          if (!response.ok || result.status >= 400) {
            throw new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : config.labels.error);
          }
          const destination = root.dataset.destination === 'checkout' ? root.dataset.checkoutUrl : root.dataset.cartUrl;
          window.location.assign(destination);
        } catch (failure) {
          error.textContent = failure.message || config.labels.error;
          error.hidden = false;
          error.focus({ preventScroll: true });
          error.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          pending = false;
          update();
        }
      });
      stickyButton?.addEventListener('click', () => {
        if (!pending && launchReady && currentVariant()?.available) form.requestSubmit(mainButton);
      });
      if ('IntersectionObserver' in window && mainButton && sticky) {
        const observer = new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, { threshold: 0 });
        observer.observe(mainButton);
        root._testObserver = observer;
      }
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-test-product]').forEach((root) => root._testObserver?.disconnect()));
})();
